<template>
  <b-modal
    :id="id"
    :topicId="topicId"
    :messageId="messageId"
    :commentId="commentId"
    :viewer="viewer"
    hide-header
    hide-footer
    centered
  >
    <template #default="{ close }">
      <div v-html="content" />
      <div style="background-color: #f4f4f4; height: 2px; width: 100%"></div>
      <b-row class="d-flex my-3" style="justify-content: space-around">
        <cancel label="キャンセル" v-on:cancel="close" />
        <confirm label="削除" variant="danger" v-on:confirm="onClick(close)" />
      </b-row>
    </template>
  </b-modal>
</template>

<script lang="ts">
import { computed, defineComponent, type PropType } from "vue";
import { createDummyDirectUser } from "../direct-utility";
import { User } from "../model";
import type { UpdateCommentPayload } from "../store";
import Confirm from "./button/Confirm.vue";
import Cancel from "./button/Cancel.vue";
import { useLegacyRootEvent } from "../composables/useLegacyRootEvent";

export default defineComponent({
  name: "delete-modal",
  components: { Confirm, Cancel },
  props: {
    id: { type: String, default: "", required: true },
    /** Topicを削除する場合に指定 */
    topicId: { type: String, default: undefined },
    messageId: { type: String, default: "" },
    commentId: { type: String, default: "" },
    viewer: { type: Object as PropType<User>, default: () => createDummyDirectUser() },
    type: { type: String, default: "message" },
  },
  setup(props, { emit }) {
    const rootEvent = useLegacyRootEvent();

    const content = computed((): string => {
      switch (props.type) {
        case "topic":
          return "話題を削除します。<br>削除すると投稿やコメントも削除されます。<br>よろしいですか？";
        case "message":
          return "投稿を削除します。<br>削除すると投稿内のコメントも削除されます。<br>よろしいですか?";
        case "comment":
          return "コメントを削除します。<br>よろしいですか?";
        default:
          return "";
      }
    });

    /* 削除処理 */
    const onClick = (closeEvent: () => void): void => {
      const param: { deleted: boolean; deletedUser: string } = {
        deleted: true,
        deletedUser: props.viewer.directId,
      };

      let obj: Record<string, unknown>;
      let event: string;
      switch (props.type) {
        case "topic":
          obj = { topicId: props.topicId, param: param };
          event = "on-topic-delete";
          break;
        case "message":
          obj = { messageId: props.messageId, param: param };
          event = "on-message-edit";
          break;
        case "comment":
          obj = {
            messageId: props.messageId,
            commentId: props.commentId,
            param: param,
          } as UpdateCommentPayload;
          event = "on-comment-edit";
          break;
        default:
          obj = {};
          event = "";
          break;
      }
      if (event) {
        rootEvent.emit(event, obj);
        emit(event, obj);
      }
      closeEvent();
    };

    return { content, onClick };
  },
});
</script>
